import React from 'react';
import { useEffect, useState } from "react";
import Select from "react-select";

interface SelectOption {
	label: string,
	value: string,
	groupVal?: string
}

interface SelectGroup {
	label?: string,
	options?: SelectOption[]
}

interface SelectorProps {
	baseUrl?: string;
	onSelect?: (payload: any | undefined) => void; //(payload: { [key: number]: number } | undefined) => void;
	onGeomChange?: (geom: string | undefined) => void;
	useProcent?: boolean;
	onProcentUpdate?: () => void;
	usePie?: boolean;
	onPieUpdate?: () => void;
}

interface SelectMD {
	col1: string,
	col1_title: string,
	col2: string,
	col2_title: string,
	col3: string,
	col3_title: string,
	col4: string,
	col4_title: string,
	col5: string,
	col5_title: string,
	indic_simp: string,
	display_order: number
}

interface Selection {
	col1_title: string,
	col2_title: string,
	col3_title: string,
	col4_title: string,
	col5_title: string
}

type RecensMd = { [key: string]: { [key: string]: SelectMD } };

const defaultProps = {
	baseUrl:'https://services.geo-spatial.org/geoserver/recensamant/ows?service=WFS&version=2.0.0'
};

const GEOM_OPTIONS: SelectOption[] = [{ label: "Județ", value: "JUDET" }, { label: "Municipii, orașe și comune", value: "UAT" }, { label: "Localitate", value: "LOC" }];

export const Selector: React.FC<SelectorProps> = (props: SelectorProps) => {
	const { baseUrl, onSelect, onGeomChange, useProcent, onProcentUpdate, usePie, onPieUpdate } = {
		...defaultProps, ...props
	};

	const [recens, setRecens] = useState<({ [key: string]: RecensMd }) | undefined>(undefined);
	const [options, setOptions] = useState<(SelectGroup[]) | undefined>(undefined);
	const [trueIndSelection, SetTrueIndSelection] = useState<SelectGroup | undefined>(undefined);
	const [indSelection, SetIndSelection] = useState<[string | undefined, string | undefined] | undefined>(undefined);
	const [geomOpts, SetGeomOpts] = useState<SelectOption[] | undefined>(undefined);
	const [geomSelection, SetGeomSelection] = useState<SelectOption | undefined | null>(undefined);
	const [othSelection, SetOthSelection] = useState<Selection | undefined>(undefined);
	const [col1Opts, setCol1Opts] = useState<({ key: string }[]) | undefined>(undefined);
	const [col2Opts, setCol2Opts] = useState<({ key: string }[]) | undefined>(undefined);
	const [col3Opts, setCol3Opts] = useState<({ key: string }[]) | undefined>(undefined);
	const [selCol1, setSelCol1] = useState<string | undefined>(undefined);
	const [selCol2, setSelCol2] = useState<string | undefined>(undefined);
	const [selCol3, setSelCol3] = useState<string | undefined>(undefined);


	const updateOthSelection = (): void => {
		if (recens && indSelection && geomSelection) {
			const newCols = recens[indSelection[0] as string][indSelection[1] as string][geomSelection.value];
			SetOthSelection(newCols);
			if (newCols.col1)
				fetch(`${baseUrl}&request=GetFeature&typeName=recensamant%3Adim_date_demografie&PROPERTYNAME=col_value,num_order&` +
					`outputformat=application/json&cql_filter=indic='${newCols.indic_simp}' AND col_name='col1'`)
					.then(response => response.json())
					.then(response => {
						const cols = (response.features as any[]).sort((a: any, b: any) => (a.properties.num_order - b.properties.num_order)).map((val) => val.properties.col_value);
						//debugger;
						let def = cols.find((val) => val === 'Total');
						if (!def)
							def = cols[0];
						setSelCol1(def);
						setCol1Opts(cols.map((val) => ({ key: val })));
					})
			else
				setCol1Opts(undefined);
			if (newCols.col2)
				fetch(`${baseUrl}&request=GetFeature&typeName=recensamant%3Adim_date_demografie&PROPERTYNAME=col_value,num_order&` +
					`outputformat=application/json&cql_filter=indic='${newCols.indic_simp}' AND col_name='col2'`)
					.then(response => response.json())
					.then(response => {
						const cols = (response.features as any[]).sort((a: any, b: any) => (a.properties.num_order - b.properties.num_order)).map((val) => val.properties.col_value);
						let def = cols.find((val) => val === 'Total');
						if (!def)
							def = cols[0];
						setSelCol2(def);
						setCol2Opts(cols.map((val) => ({ key: val })));
					})
			else
				setCol2Opts(undefined);
			if (newCols.col3)
				fetch(`${baseUrl}&request=GetFeature&typeName=recensamant%3Adim_date_demografie&PROPERTYNAME=col_value,num_order&` +
					`outputformat=application/json&cql_filter=indic='${newCols.indic_simp}' AND col_name='col3'`)
					.then(response => response.json())
					.then(response => {
						const cols = (response.features as any[]).sort((a: any, b: any) => (a.properties.num_order - b.properties.num_order)).map((val) => val.properties.col_value);
						let def = cols.find((val) => val === 'Total');
						if (!def)
							def = cols[0];
						setSelCol3(def);
						setCol3Opts(cols.map((val) => ({ key: val })));

					})
			else
				setCol3Opts(undefined);
		}
		else {
			SetOthSelection(undefined);
			setCol1Opts(undefined);
			setCol2Opts(undefined);
			setCol3Opts(undefined);
		}
	}

	const updateProcent = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (onProcentUpdate)
			onProcentUpdate();
	}

	const updatePie = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (onPieUpdate)
			onPieUpdate();
	}

	useEffect(() => {
		fetch(`${baseUrl}&request=GetFeature&typeName=recensamant%3Am_metadata&maxFeatures=50&outputFormat=application%2Fjson&cql_filter=ignore<>1`)
			.then(response => response.json())
			.then(response => {
				const recensamant: { [key: string]: RecensMd } = {};
				(response.features as any[]).forEach(
					(feat) => {
						let grup: RecensMd = recensamant[feat.properties.categorie];
						if (!grup) {
							grup = {};
							recensamant[feat.properties.categorie] = grup;
						}
						let indicator = grup[feat.properties.titlu_full];
						if (!indicator) {
							indicator = {};
							grup[feat.properties.titlu_full] = indicator;
						}
						indicator[feat.properties.geom_type] = feat.properties;
					}
				);

				setRecens(recensamant);
			})
	}, [baseUrl]);

	useEffect(() => {
		//console.log("s-a initializat recensamantul", recens);
		if (!recens)
			return;
		//debugger;
		var opts = Object.keys(recens).sort().map((key) => {
			return {
				label: key, options: Object.keys(recens[key]).map((ikey) => ({ label: ikey, value: ikey, groupVal: key, sortOrder: Object.values(recens[key][ikey])[0].display_order })).sort((a, b) => (a.sortOrder - b.sortOrder))
			}
		}).sort();
		setOptions(opts);
		SetTrueIndSelection(opts[0].options[0]);
		SetIndSelection([(opts[0].options[0] as SelectOption).groupVal, opts[0].options[0]?.label]);

	}, [recens]);

	useEffect(() => {
		//console.log("s-a schimbat indicatorul", indSelection);
		if (recens && indSelection) {
			//console.log("schimb geometria", GEOM_OPTIONS, recens[indSelection[0] as string][indSelection[1] as string]);
			const optz = GEOM_OPTIONS.filter((val) => val.value in recens[indSelection[0] as string][indSelection[1] as string]);
			if (geomSelection?.value === optz[0].value)
				updateOthSelection();
			else
				SetGeomSelection(optz[0]);
			SetGeomOpts(optz);
		}
		else {
			//console.log("resetez geometria");
			SetGeomSelection(undefined);
		}
		setSelCol1(undefined);
		setSelCol2(undefined);
		setSelCol3(undefined);
		if (onSelect)
			onSelect(undefined);
	}, [indSelection]);

	useEffect(() => {
		//console.log("s-a schimbat geometria. era", geomSelection);
		if (onGeomChange)
			onGeomChange(geomSelection?.value);
		setSelCol1(undefined);
		setSelCol2(undefined);
		setSelCol3(undefined);
		updateOthSelection();
		
	}, [geomSelection]);

	useEffect(() => {
		//console.log("s-a schimbat selectia", selCol1, selCol2, selCol3, useProcent);
		if (recens && indSelection && geomSelection) {

			const newCols = recens[indSelection[0] as string][indSelection[1] as string][geomSelection.value];
			if (selCol1 && (!newCols.col2 || selCol2) && (!newCols.col3 || selCol3)) {
				if (!usePie) {
					const url = `${baseUrl}&request=GetFeature&typeName=recensamant%3Adate_demografie_opt&PROPERTYNAME=${useProcent ? 'procent' : 'valoare'},geom_code&` +
						`outputformat=application/json&cql_filter=indic='${newCols.indic_simp}' AND col1='${selCol1}'` +
						(newCols.col2 ? `AND col2 = '${selCol2}'` : '') + (newCols.col3 ? `AND col3 = '${selCol3}'` : '');
					fetch(url)
						.then(response => response.json())
						.then(response => {
							const date: { [key: number]: number } = {};
							(response.features as any[]).forEach((val) => { date[val.properties.geom_code] = val.properties[useProcent ? 'procent' : 'valoare']; });
							if (onSelect) {
								onSelect(date);
							}
						})
				}
				else {
					const segmCol = (newCols.col3 ? 'col3' : (newCols.col2 ? 'col2' : 'col1'));
					const segmOpts = (newCols.col3 ? col3Opts : (newCols.col2 ? col2Opts : col1Opts));
					const url = `${baseUrl}&request=GetFeature&typeName=recensamant%3Adate_demografie_opt&PROPERTYNAME=${useProcent ? 'procent' : 'valoare'},geom_code,` +
						segmCol +
						`&outputformat=application/json&cql_filter=indic='${newCols.indic_simp}'` + (newCols.col2 ? `AND col1 = '${selCol1}'` : '') +
						(newCols.col3 ? `AND col2 = '${selCol2}'` : '');
					fetch(url)
						.then(response => response.json())
						.then(response => {
							//debugger;
							const date: {
								[key: number]: {
									total?: number, slices: any[]
								}
							} = {};
							(response.features as any[]).forEach((val) => {
								if (!(val.properties.geom_code in date))
									date[val.properties.geom_code] = {
										slices: []
									};
								const dt = date[val.properties.geom_code];
								if (val.properties[segmCol] == 'Total')
									dt.total = val.properties.valoare;
								else
									dt.slices.push([val.properties[segmCol], val.properties.valoare]);
							});
							console.log(segmOpts);
							for (const [k, v] of Object.entries(date)) {
								v.slices.forEach((v) => console.log(v[0], segmOpts?.findIndex((q)=>q.key==v[0])));
								v.slices = v.slices.sort((a, b) => (segmOpts?.findIndex((q) => q.key === a[0]) || 0) - (segmOpts?.findIndex((q) => q.key === b[0])||0));
							}

							if (onSelect) {
								onSelect(date);
							}
						})
				}
			}
		}

	}, [selCol1, selCol2, selCol3, useProcent, usePie]);


	if (!options)
		return null;
	return <div className="Selector">
		<h2>Indicatorul</h2>
		<Select<SelectGroup>
			value={trueIndSelection}
			onChange={(lindic) => { SetTrueIndSelection(lindic as SelectOption);  SetIndSelection([(lindic as SelectOption).groupVal, lindic?.label]) }}
			options={options}
			classNames={{singleValue: () =>	'nowrap'}}		/>
			{
			(recens && indSelection) ? (
				<div>
					<h2>Nivel administrativ</h2>
					<Select<SelectOption>
						value={geomSelection}
						onChange={(geom) => SetGeomSelection(geom)}
						options={geomOpts}
					/></div>):null
			}
			{
			(recens && indSelection && geomSelection && othSelection && othSelection.col1_title && (!usePie || othSelection.col2_title))  ? (<div>
				<h2>{othSelection.col1_title}</h2>
				<Select<{ key: string }>
					value={selCol1 ? { key: selCol1 } : undefined}
					options={col1Opts}
					getOptionLabel={option => option.key}
					getOptionValue={option => option.key}
					classNames={{ singleValue: () => 'nowrap' }}
					onChange={(val) => setSelCol1(val?.key)}
				/>
			</div>) : null
		}
		{
			(recens && indSelection && geomSelection && othSelection && othSelection.col2_title && (!usePie || othSelection.col3_title)) ? (<div>
				<h2>{othSelection.col2_title}</h2>
				<Select<{ key: string }>
					value={selCol2 ? { key: selCol2 } : undefined}
					options={col2Opts}
					getOptionLabel={option => option.key}
					getOptionValue={option => option.key}
					classNames={{ singleValue: () => 'nowrap' }}
					onChange={(val) => setSelCol2(val?.key)}
				/>
			</div>) : null
		}
		{
			(recens && indSelection && geomSelection && othSelection && othSelection.col3_title && (!usePie || othSelection.col4_title)) ? (<div>
				<h2>{othSelection.col3_title}</h2>
				<Select<{ key: string }>
					value={selCol3 ? { key: selCol3 } : undefined}
					options={col3Opts}
					getOptionLabel={option => option.key}
					getOptionValue={option => option.key}
					classNames={{ singleValue: () => 'nowrap' }}
					onChange={(val) => setSelCol3(val?.key)}
				/>
			</div>) : null
		}
		{
			(recens && indSelection && geomSelection && othSelection && !usePie) ? (<div>				
				<div>
					<label>
						<input
							type="checkbox"
							checked={useProcent}
							onChange={updateProcent}
						/>
						În procente din total {othSelection.col3_title || othSelection.col2_title || othSelection.col1_title}
					</label>
				</div>
			</div>) : null
		}
		{
			(recens && indSelection && geomSelection && othSelection) ? (<div>
				<div>
					<label>
						<input
							type="checkbox"
							checked={usePie}
							onChange={updatePie}
						/>
						Arată grafic-plăcintă pentru {othSelection.col3_title || othSelection.col2_title || othSelection.col1_title}
					</label>
				</div>
			</div>) : null
		}
			</div>;
};